import React from 'react'
import PropTypes from 'prop-types'
import {
  Grid,
  CircularProgress
} from '@mui/material'

const Loading = (props) => {
  return (
    <Grid
      container
      direction='column'
      justifyContent='center'
      alignItems='center'
    >
      <h3>{(props.text) ? props.text : 'loading...'}</h3>
      <CircularProgress />
    </Grid>
  )
}

Loading.propTypes = {
  main: PropTypes.bool
}

export default Loading
